import React, { Suspense } from 'react';
import { LoadPreview3DScripts } from './loadPreview3DScripts';
import { LoadProduct } from './loadProduct';
import { LoadSceneData } from './loadSceneData';

export const LoadPreview3D = ({
    children,
    productId,
    productCode,
    fallback,
    onSceneLoaded
}: {
    children: React.ReactNode;
    fallback: React.ReactNode;
    productId?: string | null;
    productCode?: string | null;
    onSceneLoaded: (isNew: boolean) => void;
}) => {
    return (
        <LoadPreview3DScripts fallback={fallback}>
            <Suspense fallback={fallback}>
                <LoadProduct productId={productId} productCode={productCode}>
                    <LoadSceneData onSceneLoaded={onSceneLoaded}>{children}</LoadSceneData>
                </LoadProduct>
            </Suspense>
        </LoadPreview3DScripts>
    );
};
